var map = {
	"./de.png": "YJf4",
	"./en.png": "Z14W",
	"./es.png": "Vbsq",
	"./fr.png": "OH1M",
	"./ja.png": "I/B4",
	"./ko.png": "Z+6T",
	"./pt.png": "PWxi",
	"./ru.png": "S7XU",
	"./th.png": "wrf6",
	"./zh-Hant.png": "Wl6t"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ui4y";